import store from 'store';
import { ACT_GET_DATA_BY_PARTNER_AND_STEP, ACT_CMS } from 'store/actions/act';
import { GET_PARTNER_DATA, GET_PARTNER_DATA_BY_TRANSACTION_ID } from 'store/actions/ui';
import { lsGetAct } from 'helpers/store';

const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Identity = () => import(/* webpackChunkName: "pages/views/identity" */ 'views/Identity');
const Legal = () => import(/* webpackChunkName: "pages/views/legal" */ 'views/Legal');
const Act = () => import(/* webpackChunkName: "pages/views/act" */ 'views/Act');
const Sign = () => import(/* webpackChunkName: "pages/views/sign" */ 'views/Sign');
const IdentityGuid = () =>
  import(/* webpackChunkName: "pages/views/identity" */ 'views/IdentityGuid');
const OkData = () => import(/* webpackChunkName: "pages/views/okdata" */ 'views/OkData');
const SignCompleted = () =>
  import(/* webpackChunkName: "pages/views/signcompleted" */ 'views/SignCompleted');
// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

// Redirect to the 404 page
// eslint-disable-next-line no-unused-vars
const redirectTo404Page = (next, path) => next({ name: '404', params: { 0: path } });

export default [
  {
    path: '/',
    component: Layout,
    beforeEnter(to, from, next) {
      if (!to.params.partnerId && to.path === '/') {
        next({ name: 'identity', params: { partnerId: process.env.DEFAULT_PARTNER } });
      } else {
        next();
      }
    },
    children: [
      {
        path: '/:partnerId(\\d+)',
        component: Identity,
        meta: { titleKey: 'identityConcession' },
        name: 'identity',
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`ui/${GET_PARTNER_DATA}`, {
              id: to.params.partnerId
            }),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-1'
            })
          ])
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/:partnerId/act',
        component: Act,
        meta: { titleKey: 'actData' },
        name: 'act',
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`act/${ACT_GET_DATA_BY_PARTNER_AND_STEP}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-2'
            })
          ];
          if (!from.name) {
            promises.push(
              store.dispatch(`ui/${GET_PARTNER_DATA}`, {
                id: to.params.partnerId
              })
            );
          }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/:partnerId/ok-data',
        component: OkData,
        meta: { titleKey: 'okData' },
        name: 'ok-data',
        beforeEnter(to, from, next) {
          store
            .dispatch(`act/${ACT_GET_DATA_BY_PARTNER_AND_STEP}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-2a'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path:
          '/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
        component: IdentityGuid,
        meta: { titleKey: 'identityDriver' },
        name: 'identityGuid',
        beforeEnter(to, from, next) {
          store
            .dispatch(`ui/${GET_PARTNER_DATA_BY_TRANSACTION_ID}`, {
              transactionId: to.params.transactionId
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/:transactionId/sign',
        component: Sign,
        meta: { titleKey: 'signData' },
        name: 'sign',
        beforeEnter(to, from, next) {
          let partnerId = to.params.partnerId;
          if (to.name === 'sign' && lsGetAct()) {
            partnerId = lsGetAct().partnerId;
          }
          store
            .dispatch(`act/${ACT_GET_DATA_BY_PARTNER_AND_STEP}`, {
              partnerId,
              patternId: 'act-drv-paso-2'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_GET_DATA_BY_PARTNER_AND_STEP);
            });
        }
      },
      {
        path:
          '/completed/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/ok',
        component: SignCompleted,
        meta: { titleKey: 'signCompleted' },
        name: 'sign-completed',
        beforeEnter(to, from, next) {
          store
            .dispatch(`ui/${GET_PARTNER_DATA_BY_TRANSACTION_ID}`, {
              transactionId: to.params.transactionId
            })
            .then(data => {
              store
                .dispatch(`act/${ACT_GET_DATA_BY_PARTNER_AND_STEP}`, {
                  partnerId: data.partnerId,
                  patternId: 'act-drv-paso-2a'
                })
                .then(() => next())
                .catch(() => {
                  redirectToErrorPage(next, '');
                });
            })
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: 'legal/:type',
        component: Legal,
        name: 'legal',
        props: { whithoutLinksFooter: true },
        meta: { titleKey: 'legal' }
      },
      {
        path: 'error',
        name: 'error',
        component: Error,
        props: { type: '500_es-ES' },
        meta: { titleKey: 'error' }
      },
      {
        path: '*',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound' }
      }
    ]
  }
];
